import { render, staticRenderFns } from "./send-appeal-to-government.vue?vue&type=template&id=5303ba8b"
import script from "./send-appeal-to-government.vue?vue&type=script&lang=js"
export * from "./send-appeal-to-government.vue?vue&type=script&lang=js"
import style0 from "./send-appeal-to-government.vue?vue&type=style&index=0&id=5303ba8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports